export const PRICING_COPY = {
  en: {
    kicker: "Pricing",
    title: "Built for fans + sports media",
    desc: "From the casual scoreboard fan to broadcasters running a live show — there's a tier for every workflow.",
    status: {
      paid: "Payment confirmed — welcome aboard.",
      expired: "Checkout expired. Try again.",
      pending: "Payment still processing — refresh in a moment.",
      error: "Couldn't verify payment status.",
    },
    verifying: "Verifying payment…",
    mostPopular: "Most popular",
    currentFree: "Your current plan",
    useFree: "Use free plan",
    onPlan: "You're on this plan",
    redirecting: "Redirecting…",
    checkoutError: "Could not start checkout. Try again.",
    footer: "All plans bill monthly · Cancel anytime · Powered by Stripe (test mode in MVP)",
    signin: "Sign in",
    switchTo: "Switch to this plan",
    included: "Included in your plan",
    confirmFree: "Confirm · access stays until period end",
    confirmSwitch: "Confirm switch · prorated today",
    switching: "Switching…",
    toFree: "Switch to Free at period end",
    freeScheduled: "Free starts when your plan ends",
    billing: {
      title: "Your subscription",
      renews: "Renews",
      ends: "Ends",
      pastDue: "Payment failed — update your card to keep your plan.",
      cancel: "Cancel plan",
      resume: "Keep my plan",
      manage: "Manage billing",
      demo: "Demo account — plan granted without a subscription.",
      comp: "Complimentary full access — no subscription needed.",
    },
    switched: "Plan updated.",
    canceled: "Checkout canceled — no charge was made.",
    plans: {
      free: {
        name: "Free Fan", cadence: "/forever", cta: "Current plan",
        features: ["Daily scores", "Limited AI questions", "Team tracking", "Basic storylines", "Limited Fan Memory", "Limited Why It Matters explanations"],
      },
      pro: {
        name: "Pro Fan", cadence: "/month", cta: "Go Pro",
        features: ["Unlimited AI questions", "Advanced Why It Matters", "Live Game Companion", "Fantasy Impact Analysis", "Sports Card Watchlists", "Unlimited Fan Memory", "Personalized Storylines", "Team + Player Alerts", "AI Predictions"],
      },
      press_box_pro: {
        name: "Press Box Pro", cadence: "/month", cta: "Become a Pro Broadcaster", badge: "For sports media",
        features: ["Everything in Pro Fan", "Real-time talking points", "AI pregame + postgame reports", "Interview question generator", "Commentary scripts (TV / Radio)", "Historical matchup research", "Live game commentary notes", "AI stat packs", "Hot take + debate topic generator", "Breaking news analysis", "Spanish + English commentary", "Voice-ready talking points", "Broadcast prep dashboard"],
      },
    },
  },
  es: {
    kicker: "Precios",
    title: "Hecho para fans y medios deportivos",
    desc: "Desde el fan casual del marcador hasta narradores con un programa en vivo — hay un plan para cada forma de trabajar.",
    status: {
      paid: "Pago confirmado — bienvenido.",
      expired: "El pago expiró. Inténtalo de nuevo.",
      pending: "El pago aún se está procesando — actualiza en un momento.",
      error: "No pudimos verificar el estado del pago.",
    },
    verifying: "Verificando pago…",
    mostPopular: "Más popular",
    currentFree: "Tu plan actual",
    useFree: "Usar plan gratis",
    onPlan: "Ya tienes este plan",
    redirecting: "Redirigiendo…",
    checkoutError: "No se pudo iniciar el pago. Inténtalo de nuevo.",
    footer: "Todos los planes se cobran mensualmente · Cancela cuando quieras · Pagos con Stripe (modo de prueba en el MVP)",
    signin: "Iniciar sesión",
    switchTo: "Cambiar a este plan",
    included: "Incluido en tu plan",
    confirmFree: "Confirmar · conservas el acceso hasta el final del periodo",
    confirmSwitch: "Confirmar cambio · prorrateado hoy",
    switching: "Cambiando…",
    toFree: "Pasar a Gratis al final del periodo",
    freeScheduled: "Gratis empieza cuando termine tu plan",
    billing: {
      title: "Tu suscripción",
      renews: "Se renueva",
      ends: "Termina",
      pastDue: "El pago falló — actualiza tu tarjeta para conservar tu plan.",
      cancel: "Cancelar plan",
      resume: "Conservar mi plan",
      manage: "Administrar facturación",
      demo: "Cuenta demo — plan otorgado sin suscripción.",
      comp: "Acceso completo de cortesía — no necesitas suscripción.",
    },
    switched: "Plan actualizado.",
    canceled: "Pago cancelado — no se hizo ningún cargo.",
    plans: {
      free: {
        name: "Fan Gratis", cadence: "/siempre", cta: "Plan actual",
        features: ["Marcadores del día", "Preguntas de IA limitadas", "Seguimiento de equipos", "Historias básicas", "Fan Memory limitada", "Explicaciones de 'Por qué importa' limitadas"],
      },
      pro: {
        name: "Fan Pro", cadence: "/mes", cta: "Hazte Pro",
        features: ["Preguntas de IA ilimitadas", "'Por qué importa' avanzado", "Compañero en vivo", "Análisis de impacto fantasy", "Seguimiento de tarjetas deportivas", "Fan Memory ilimitada", "Historias personalizadas", "Alertas de equipos y jugadores", "Predicciones con IA"],
      },
      press_box_pro: {
        name: "Press Box Pro", cadence: "/mes", cta: "Conviértete en narrador Pro", badge: "Para medios deportivos",
        features: ["Todo lo de Fan Pro", "Puntos de conversación en tiempo real", "Reportes previos y posteriores al partido con IA", "Generador de preguntas para entrevistas", "Guiones de narración (TV / Radio)", "Investigación histórica de enfrentamientos", "Notas de narración en vivo", "Paquetes de estadísticas con IA", "Generador de opiniones picantes y temas de debate", "Análisis de noticias de último momento", "Narración en español e inglés", "Puntos de conversación listos para voz", "Panel de preparación de transmisión"],
      },
    },
  },
};
